var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-content"},[_c('div',{staticClass:"report-container"},[_vm._t("pageContent")],2),_c('div',{staticClass:"report-info"},[_c('div',{staticClass:"pull-right"},[_vm._v(" Powered by Noteunlimited Inc. "),_c('img',{staticClass:"summary-report-logo-powered",attrs:{"src":_vm.logoImage}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }